import { apiClient } from "./client";

export const userAPI = {
  login(username, password) {
    const body = new URLSearchParams();
    body.append("username", username);
    body.append("password", password);

    return apiClient.post("/users/login", body, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
  },
  postUser(username, displayname, department, email?, ouname?) {
    return apiClient.post("/users", {
      username,
      displayname,
      department,
      ...(email ? { email } : {}),
      ...(ouname ? { ouname } : {}),
    });
  },
  users() {
    return apiClient.get("/users");
  },
  getUser(username) {
    return apiClient.get(`/users/${username}`);
  },
  deleteUser(username) {
    return apiClient.delete(`/users/${username}`);
  },
  passwordFirstChange(username, oldpassword, newpassword) {
    const body = new URLSearchParams();
    body.append("oldpassword", oldpassword);
    body.append("newpassword", newpassword);

    return apiClient.put(
      `/users/${encodeURIComponent(username)}/password/first_login`,
      body,
      {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }
    );
  },

  dashboard() {
    return apiClient.get("/dashboard");
  },
};
